import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import { ToastrService } from 'ngx-toastr';
declare var $ : any;

@Component({
  selector: 'app-lms-content-editior',
  templateUrl: './lms-content-editior.component.html',
  styleUrls: ['./lms-content-editior.component.scss']
})
export class LmsContentEditiorComponent implements OnInit {

  myForm: FormGroup;
  routeParams: any;
  // appType: any;
  // courseId:string;
  htmlText:""
  selectedFile: File;
  previewUrl: string | ArrayBuffer;
  isImage: any;
  formData=new FormData();
  file :File
  videoProgress: number = 0
  fileSizeUnit: number = 1024;
  FileSize: any
  FileProgessSize: any
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl

  // topicId: any;
  @Input() appType: any;
  @Input() courseId: any;
  @Input() topicId: any;
  @Input() selectedApp: any;
  @Input() title: any;
  // @ViewChild('cancelBtn') cancelBtn: ElementRef;

  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  // @Output() refreshFriendCircleList: EventEmitter<any> = new EventEmitter();
  currentUrl:any
  resources_list=[]
  selected_resources =[]
  app_tag_cat_id= '648956a313fb47cb1a45e844' //'648058e70c699e0bd984ec30'
  app_tags_list=[]
  selected_app_tag ='64884b753ec230f996841247'
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private router:Router,
    private toast:ToastrService,
    private apiService:ApiService) {
      this.currentUrl = this.route.snapshot.routeConfig.path
     }

  ngOnInit() {
    // this.route.params.subscribe(params => {
    //   // This will be called every time the route params change
    //   this.routeParams = params;
    // });
    // const queryParams = this.route.snapshot.queryParams;
    // this.appType=queryParams?.app 
    // this.courseId=queryParams?.courseId 
    // this.topicId=queryParams?.topicId 
    // Create the form group with one form control for the title input
    this.myForm = this.fb.group({
      title: ['', Validators.required],
      url_link: ['',],
      aws_s3_file_url: ['',],
      content_scripts: ['',],
      teachers_notes: ['', ],
      // appCode: ['',],
      app_tag: ['',],
      description	: ['',],
    });
    this.getResourceList()
    this.appTags()
  }
  ngOnChanges() {

    this.selected_app_tag ='64884b753ec230f996841247'

    if( this.selectedApp){
      this.selected_app_tag ='64884b753ec230f996841247'

      // console.log('appType>>>>>>>.', this.selectedApp)
      this.appType = this.selectedApp ? this.selectedApp.type : null
      
    }
    // console.log('appType>>>>>>>.', this.appType)

   
    if (this.selectedApp) {
      this.myForm.get("title").patchValue(this.selectedApp.title);
      this.myForm.get("description").patchValue(this.selectedApp.description);
      this.myForm.get("content_scripts").patchValue(this.selectedApp.content_scripts);
      // this.myForm.get("appCode").patchValue(this.selectedApp?.app_code);
      this.myForm.get("teachers_notes").patchValue(this.selectedApp.teachers_notes);

      this.myForm.get("url_link").patchValue(this.selectedApp.url_link);
      this.myForm.get("aws_s3_file_url").patchValue(this.selectedApp.aws_s3_file_url);
      if(this.selectedApp.app_tag){
        let app_tag = this.selectedApp.app_tag.map((item)=>item)
        this.selected_app_tag = app_tag[0]?._id
      }
      if(this.selectedApp.resources){
        this.selected_resources = this.selectedApp.resources.map((item)=>item._id)
      }

      // console.log('myForm =>>>>>>>',this.myForm)
      if (this.selectedApp.type == 'image' || this.selectedApp.type == 'video') {
        this.previewUrl = this.s3MediaUrl + this.selectedApp.content
        this.file = this.selectedApp.content

      }
      if (this.selectedApp.type == 'text') this.htmlText = this.selectedApp.content

    }

  }
  appTags(){
      this.apiService.getTagByTagCatgoryId(this.app_tag_cat_id).subscribe((res: any) => {
        if(res.statusCode===200){
          this.app_tags_list = res?.data
        }
      })
    }
  getAppTagId(event:any){
    this.selected_app_tag
  }
  getResourceList() {
    this.apiService.getResourceList(1, 100).subscribe((res: any) => {
      if(res.statusCode === 200){
        this.resources_list = res?.items
      }
    })
  }
  getResourceId(event:any){
    this.selected_resources
  }
  resetModalContent(){
    this.close()
  }
  close(): void {
    this.closeModal.emit();
    this.myForm.reset()
    this.selected_resources = null
    // this.selected_app_tag = ''
    this.previewUrl = ''
    this.htmlText =''
    this.formData = new FormData()
    this.file = null
    // this.appType = null
    this.courseId = null
    // this.topicId = null
    this.selectedApp = null
    this.title = null

    // this.cancelBtn?.nativeElement?.click();
    $('#app-model').modal('hide');
  }
  //events starts
  setFocus($event) {
    $event.focus();
  }
  onFileSelected(event): void {

    const fileInput = event.target as HTMLInputElement;
    switch(this.currentUrl){
      case 'lmss':
        if(this.selectedApp && this.selectedApp._id){
          if (fileInput.files && fileInput.files.length > 0) {
            this.file = fileInput.files[0];
            this.selectedFile = fileInput.files[0];
            // this.formData.append('file',fileInput.files[0])
            const mimeType = this.selectedFile.type;
            this.isImage = mimeType.startsWith('image');
            // this.isVideo = mimeType.startsWith('video');
            var file = fileInput.files[0];
            // console.log("file",file)
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (_event) => {
              this.previewUrl = reader.result;
            };
            // reader.readAsDataURL(this.selectedFile);
          }
        }
        else{ if (fileInput.files && fileInput.files.length > 0) {
          this.file = fileInput.files[0];
          this.selectedFile = fileInput.files[0];
          // this.formData.append('file',this.selectedFile)
          const mimeType = this.selectedFile.type;
          this.isImage = mimeType.startsWith('image');
          // this.isVideo = mimeType.startsWith('video');
          var file = fileInput.files[0];
          // console.log("file",file)
          var reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = (_event) => {
            this.previewUrl = reader.result;
          };
          // reader.readAsDataURL(this.selectedFile);
        }}
      break;
      case 'lmss/list':
        if(this.selectedApp && this.selectedApp._id){
          if (fileInput.files && fileInput.files.length > 0) {
            this.file = fileInput.files[0];
            this.selectedFile = fileInput.files[0];
            // this.formData.append('file',this.selectedFile)
            const mimeType = this.selectedFile.type;
            this.isImage = mimeType.startsWith('image');
            // this.isVideo = mimeType.startsWith('video');
            var file = fileInput.files[0];
            // console.log("file",file)
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (_event) => {
              this.previewUrl = reader.result;
            };
            // reader.readAsDataURL(this.selectedFile);
          }
        }
        else{ if (fileInput.files && fileInput.files.length > 0) {
          this.file = fileInput.files[0];
          this.selectedFile = fileInput.files[0];
          // this.formData.append('file',this.selectedFile)
          const mimeType = this.selectedFile.type;
          this.isImage = mimeType.startsWith('image');
          // this.isVideo = mimeType.startsWith('video');
          var file = fileInput.files[0];
          // console.log("file",file)
          var reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = (_event) => {
            this.previewUrl = reader.result;
          };
          // reader.readAsDataURL(this.selectedFile);
        }}
      break;
    }
    
  }
 
  
  onSubmit() {
    switch(this.currentUrl){
      case 'lmss' :
        if(this.selectedApp && this.selectedApp._id){
          this.formData=new FormData()
          this.formData.append('title',this.myForm.value.title)
          this.formData.append('name',this.myForm.value.title)
          // this.formData.append('resources',this.selected_resources)
          this.selected_resources.forEach((resources, index) => {
            this.formData.append(`resources[${index}]`, resources);
          });
          this.formData.append('app_tag',this.selected_app_tag)
          this.formData.append('description',this.myForm.value.description)
          this.formData.append('content_scripts',this.myForm.value.content_scripts)
          this.formData.append('teachers_notes',this.myForm.value.teachers_notes)
          // this.formData.append('app_code',this.myForm.value.appCode)
          this.formData.append('topic',this.topicId)
          this.formData.append('type',this.appType)
          this.formData.append('file',this.file)
        
          if(this.appType=='image'||this.appType=='video'){
            if (this.formData.has('file')) {
              // console.log('File exists');
            } if(this.myForm.value.url_link){
                this.formData.append('url_link',this.myForm.value.url_link)
                this.formData.append('isurl_link','true')
            }
            if(this.myForm.value.aws_s3_file_url){
              this.formData.append('aws_s3_file_url',this.myForm.value.aws_s3_file_url)
              this.formData.append('isurl_link','true')
            }
            // else{
            //   this.toast.error(`plese upload ${this.appType} or past url link`)
            // }
          }
          else{
          this.formData.append('content',this.htmlText)
          }
          // this.formData.forEach(function(value, key) {
          //   console.log('key',key + ': ' + 'value',value);
          // });
            this.apiService.updateApp(this.selectedApp._id,this.formData).subscribe((res)=>{
              if (res['loaded'] && res['total']) {
                this.videoProgress = Math.round(res['loaded'] / res['total'] * 100)
                if (res['type'] == 1) {
                  this.FileSize = this.getFileSize(res['total']) +
                    ' ' + this.getFileSizeUnit(res['total']),
                    this.FileProgessSize = this.getFileSize(res['loaded']) +
                    ' ' + this.getFileSizeUnit(res['loaded'])
                }
              }
              // this.ngxLoader.stop()
              if (res['body']?.data !== undefined) {
                if(res['body']?.isSuccess) {
                  // this.router.navigate([`/lmss/${this.courseId}`])
                  this.close()
                }
                else{
                  this.toast.error("Somthing went wrong")
                }
                //     this.user.provider_video = res['body']?.data.provider_video
                // interval(100).subscribe(x => {
                //   this.user.provider_video = res['body']?.data.provider_video
                // });
                this.videoProgress = 0
              }
            })
          }
          else {
            this.formData=new FormData()
            this.formData.append('title',this.myForm.value.title)
            this.formData.append('name',this.myForm.value.title)
            // this.formData.append('resources',this.selected_resources)
            this.selected_resources.forEach((resources, index) => {
              this.formData.append(`resources[${index}]`, resources);
            });
            this.formData.append('app_tag',this.selected_app_tag)
            this.formData.append('description',this.myForm.value.description)
            this.formData.append('content_scripts',this.myForm.value.content_scripts)
            this.formData.append('teachers_notes',this.myForm.value.teachers_notes)
            // this.formData.append('app_code',this.myForm.value.appCode)
            this.formData.append('topic',this.topicId)
            this.formData.append('type',this.appType)
            this.formData.append('file',this.file)
            if(this.appType=='image'||this.appType=='video'){
              if (this.formData.has('file')) {
                // console.log('File exists');
              } if(this.myForm.value.url_link){
                  this.formData.append('url_link',this.myForm.value.url_link)
                  this.formData.append('isurl_link','true')
              }
              if(this.myForm.value.aws_s3_file_url){
                this.formData.append('aws_s3_file_url',this.myForm.value.aws_s3_file_url)
                this.formData.append('isurl_link','true')
              }
              else{
                this.toast.error(`plese upload ${this.appType} or past url link`)
              }
            }
            else{
            this.formData.append('content',this.htmlText)
            }
            
            // isurl_link
              this.apiService.addApp(this.formData).subscribe((res)=>{
                if (res['loaded'] && res['total']) {
                  this.videoProgress = Math.round(res['loaded'] / res['total'] * 100)
                  if (res['type'] == 1) {
                    this.FileSize = this.getFileSize(res['total']) +
                      ' ' + this.getFileSizeUnit(res['total']),
                      this.FileProgessSize = this.getFileSize(res['loaded']) +
                      ' ' + this.getFileSizeUnit(res['loaded'])
                  }
                }
                // this.ngxLoader.stop()
                if (res['body']?.data !== undefined) {
                  if(res['body']?.isSuccess) {
                    // this.router.navigate([`/lmss/${this.courseId}`])
                    this.close()

                  }
                  else{
                    this.toast.error("Somthing went wrong")
                  }
                  //     this.user.provider_video = res['body']?.data.provider_video
                  // interval(100).subscribe(x => {
                  //   this.user.provider_video = res['body']?.data.provider_video
                  // });
                  this.videoProgress = 0
                }
              })
      
          }
      break;
      case 'lmss/list':
        if(this.selectedApp && this.selectedApp._id){
          this.formData=new FormData()
          this.formData.append('title',this.myForm.value.title)
          // this.formData.append('resources',this.selected_resources)
          this.selected_resources.forEach((resources, index) => {
            this.formData.append(`resources[${index}]`, resources);
          });
          this.formData.append('app_tag',this.selected_app_tag)
          this.formData.append('description',this.myForm.value.description)
          this.formData.append('content_scripts',this.myForm.value.content_scripts)
          this.formData.append('teachers_notes',this.myForm.value.teachers_notes)
          // this.formData.append('app_code',this.myForm.value.appCode)
          this.formData.append('type',this.appType)
          this.formData.append('file',this.file)

          if(this.appType=='image'||this.appType=='video'){
            if (this.formData.has('file')) {
              // console.log('File exists');
            } 
             if(this.myForm.value.url_link){
                this.formData.append('url_link',this.myForm.value.url_link)
                this.formData.append('isurl_link','true')
                
            }
            if(this.myForm.value.aws_s3_file_url){
              this.formData.append('aws_s3_file_url',this.myForm.value.aws_s3_file_url)
              this.formData.append('isurl_link','true')
            }
            // else{
            //   this.toast.error(`please upload ${this.appType} or past url link`)
            // }
          }
          // console.log('appcode',this.myForm.value.appCode,this.formData.has('appcode'))
            this.apiService.updateApp(this.selectedApp._id,this.formData).subscribe((res)=>{
              if (res['loaded'] && res['total']) {
                this.videoProgress = Math.round(res['loaded'] / res['total'] * 100)
                if (res['type'] == 1) {
                  this.FileSize = this.getFileSize(res['total']) +
                    ' ' + this.getFileSizeUnit(res['total']),
                    this.FileProgessSize = this.getFileSize(res['loaded']) +
                    ' ' + this.getFileSizeUnit(res['loaded'])
                }
              }
              // this.ngxLoader.stop()
              if (res['body']?.data !== undefined) {
                if(res['body']?.isSuccess) {
                  // this.router.navigate([`/lmss/${this.courseId}`])
                  this.close()
                }
                else{
                  this.toast.error("Somthing went wrong")
                }
                //     this.user.provider_video = res['body']?.data.provider_video
                // interval(100).subscribe(x => {
                //   this.user.provider_video = res['body']?.data.provider_video
                // });
                this.videoProgress = 0
              }
            })
          }
          else{
          this.formData=new FormData()
            this.formData.append('title',this.myForm.value.title)
            this.formData.append('name',this.myForm.value.title)
            // this.formData.append('resources',this.selected_resources)
            this.selected_resources.forEach((resources, index) => {
              this.formData.append(`resources[${index}]`, resources);
            });
            this.formData.append('app_tag',this.selected_app_tag)
            this.formData.append('description',this.myForm.value.description)
            this.formData.append('content_scripts',this.myForm.value.content_scripts)
            this.formData.append('teachers_notes',this.myForm.value.teachers_notes)
            // this.formData.append('app_code',this.myForm.value.appCode)
            this.formData.append('type',this.appType)
            this.formData.append('file',this.file)

            if(this.appType=='image'||this.appType=='video'){
              if (this.formData.has('file')) {
                // console.log('File exists');
              }  if(this.myForm.value.url_link){
                  this.formData.append('url_link',this.myForm.value.url_link)
                  this.formData.append('isurl_link','true')
              }
              if(this.myForm.value.aws_s3_file_url){
                this.formData.append('aws_s3_file_url',this.myForm.value.aws_s3_file_url)
                this.formData.append('isurl_link','true')
              }
              else{
                this.toast.error(`plese upload ${this.appType} or past url link`)
              }
            }
            else{
            this.formData.append('content',this.htmlText)
            }
            // isurl_link
              this.apiService.addApp(this.formData).subscribe((res)=>{
                if (res['loaded'] && res['total']) {
                  this.videoProgress = Math.round(res['loaded'] / res['total'] * 100)
                  if (res['type'] == 1) {
                    this.FileSize = this.getFileSize(res['total']) +
                      ' ' + this.getFileSizeUnit(res['total']),
                      this.FileProgessSize = this.getFileSize(res['loaded']) +
                      ' ' + this.getFileSizeUnit(res['loaded'])
                  }
                }
                // this.ngxLoader.stop()
                if (res['body']?.data !== undefined) {
                  if(res['body']?.isSuccess) {
                    // this.router.navigate([`/lmss/${this.courseId}`])
                    this.close()

                  }
                  else{
                    this.toast.error("Somthing went wrong")
                  }
                  //     this.user.provider_video = res['body']?.data.provider_video
                  // interval(100).subscribe(x => {
                  //   this.user.provider_video = res['body']?.data.provider_video
                  // });
                  this.videoProgress = 0
                }
              })
          }

      break;
      default: this.toast.error('error')
    }
 
  }
  getFileSize(fileSize: number): number {
    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSize = parseFloat((fileSize / this.fileSizeUnit).toFixed(2));
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSize = parseFloat(
          (fileSize / this.fileSizeUnit / this.fileSizeUnit).toFixed(2)
        );
      }
    }

    return fileSize;
  }

  getFileSizeUnit(fileSize: number) {
    let fileSizeInWords = 'bytes';

    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit) {
        fileSizeInWords = 'bytes';
      } else if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSizeInWords = 'KB';
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSizeInWords = 'MB';
      }
    }

    return fileSizeInWords;
  }
 
}
